
(function () {
  const preload = document.createElement('link');
  preload.rel = 'preload';
  preload.href = '/wp-content/themes/frbrb/js/leaflet.js';
  preload.as = 'script';

  document.body.append(preload);

  const showMapButton = document.querySelector('.organization__map-consent button');
  const textContainer = document.querySelector('.organization__map-consent');

  const displayStatusMessage = function (message) {

    textContainer.innerHTML = `<strong>${message}</strong>`;

  };

  const showMap = function () {

    const { center, title } = frbrbSingleMapData;

    textContainer.hidden = true;
    document.querySelector('.map-wrapper').hidden = false;

    const map = L.map('map', { scrollWheelZoom: false })
      .setView(center, 15);

    L.tileLayer('https://maps.tilehosting.com/styles/basic/{z}/{x}/{y}.png?key=MihwXjSrAyh72fc566Sx', {
      attribution: '<a href="https://www.maptiler.com/license/maps/" target="_blank">© MapTiler</a> <a href="https://www.openstreetmap.org/copyright" target="_blank">© OpenStreetMap contributors</a>'
    })
      .addTo(map);

    L.marker(center)
      .addTo(map)
      .bindPopup(title);
  };

  const loadMapScript = function () {

    showMapButton.disabled = true;

    const leafletScript = document.createElement('script');
    leafletScript.src = '/wp-content/themes/frbrb/js/leaflet.js';
    leafletScript.addEventListener('load', showMap);
    leafletScript.addEventListener('error', () => displayStatusMessage(frbrbSingleMapData.loadingError));
    document.head.append(leafletScript);
    displayStatusMessage(frbrbSingleMapData.loadingMap);

  };


  showMapButton.addEventListener('click', loadMapScript);
}());



